<template>
  <head>
    <link rel="stylesheet" href="./css/main.css" />
  </head>

  <div class="common-layout">
    <el-container>
      <!-- 顶部菜单 -->
      
      <el-affix>
        <el-header>
          <el-menu
            default-active="1"
            class="el-menu-demo"
            mode="horizontal"
            :ellipsis="false"
            @select="handleSelect"
          >
            <!-- 网站图标 -->
            <img src="./img/icon.png" alt="" srcset="" class="el-header-logo" />
            <div class="flex-grow" />

            <!-- 菜单 -->
            <a href="https://taskmgr.gusui.site/"> <el-menu-item index="1">任务管理器</el-menu-item></a>
            <a href="https://www.gusui.site/"> <el-menu-item index="2">官网</el-menu-item></a>

            <el-popover v-if="isLogin" placement="top-start" :width="200" trigger="hover">
              <template #reference>
                <el-avatar
                  :src="userinfo.data.avatar"
                />
              </template>
              <template #default>
                <h2>你好，{{ userinfo.data.displayName }}！</h2>
                <!-- {{ userinfo.name }} -->
                <br />
                <el-button @click="account">用户中心</el-button>
                <el-button @click="logout">注销</el-button>
              </template>
            </el-popover>
            <el-avatar v-else @click="login">登录</el-avatar>
          </el-menu>
        </el-header>
      </el-affix>
      <el-main
        ><br /><br /><br />
        <center>
          <h1 style="font-size: 2em">✨欢迎使用谷穗社区代码构建器🎉</h1>
          <br /><br />
          <el-steps style="max-width: 600px" :active="active" align-center>
            <el-step title="准备工作" />
            <el-step title="项目配置" />
            <el-step title="调整字典" />
            <el-step title="构建项目" />
            <el-step title="项目部署" />
            <el-step title="部署完成" />
          </el-steps>
          <br /><br /><br />
          <el-card style="max-width: 480px" v-if="active == 0">
            <template #header>
              <div class="card-header">
                <span>准备工作✨</span>
                <h5 style="color:red;">如使用云构建请务必提前登录</h5>
              </div>
            </template>
            <!-- <el-form :model="form" label-width="auto" style="max-width: 600px"> -->
            <el-tabs type="border-card">
              <el-tab-pane label="上传文件">
                <div class="file-upload-wrapper">
                  <button type="button" class="file-upload-button">选择文件</button>
                  <input type="file" class="file-upload-input" @change="onFileChange" />
                </div>
              </el-tab-pane>
              <el-tab-pane label="从URL获取资源">
                <el-input v-model="jsonUrl">
                  <template #append
                    ><el-button type="primary" @click="loadData"
                      >装载</el-button
                    ></template
                  >
                </el-input>
              </el-tab-pane>
            </el-tabs>
            <!-- <el-collapse v-model="firstActiveName" accordion>
                <el-collapse-item title="上传并使用文件" name="1">
                  <div class="file-upload-wrapper">
                    <button type="button" class="file-upload-button">选择文件</button>
                    <input type="file" class="file-upload-input" @change="onFileChange" />
                  </div>
                </el-collapse-item>
                <el-collapse-item title="从URL获取资源并使用" name="2">
                  <el-input v-model="jsonUrl">
                    <template #append
                      ><el-button type="primary" @click="loadData"
                        >装载</el-button
                      ></template
                    >
                  </el-input>
                </el-collapse-item>
              </el-collapse> -->
            <!-- <el-form-item label="包名">
                    <el-input v-model="form.name" />
                </el-form-item>
                <el-form-item label="版本号">
                    <el-input v-model="form.version" />
                </el-form-item> -->
            <!-- </el-form> -->
            <!-- <el-button style="margin-top: 12px" @click="pre">上一步</el-button> -->
            <el-button style="margin-top: 12px" @click="next">下一步</el-button>
          </el-card>
          <el-card style="max-width: 480px" v-if="active == 1">
            <template #header>
              <div class="card-header">
                <span>项目配置⚙️</span>
              </div>
            </template>
            <el-form :model="form" label-width="auto" style="max-width: 600px">
              <el-form-item label="包名">
                <el-input v-model="form_name" />
              </el-form-item>
              <el-form-item label="版本号">
                <el-input v-model="form_version" />
              </el-form-item>
              <el-form-item label="描述">
                <el-input v-model="form_description" />
              </el-form-item>
            </el-form>
            <el-button style="margin-top: 12px" @click="pre">上一步</el-button>
            <el-button style="margin-top: 12px" @click="next">下一步</el-button>
          </el-card>
          <el-card style="max-width: 480px" v-if="active == 2">
            <template #header>
              <div class="card-header">
                <span>调整字典🧵</span>
              </div>
            </template>
            <el-table :data="tableData" height="300" style="width: 100%">
              <el-table-column prop="name" label="名称" />
              <el-table-column prop="description" label="描述" />
              <el-table-column prop="value" label="值">
                <template #default="scope">
                  <el-input
                    v-model="scope.row.value"
                    :autosize="{ minRows: 2, maxRows: 5 }"
                    type="textarea"
                  />
                </template>
              </el-table-column>
            </el-table>
            <br />
            <el-button style="margin-top: 12px" @click="pre">上一步</el-button>
            <el-button style="margin-top: 12px" @click="generateJson">下一步</el-button>
          </el-card>
          <el-card style="max-width: 480px" v-if="active == 3">
            <template #header>
              <div class="card-header">
                <span>构建项目📦</span>

                <el-select v-model="value" placeholder="Select" style="width: 140px">
                  <!-- <h3>&nbsp;构建模式</h3> -->
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>
            </template>
            <div v-if="!value">
              <el-card style="max-width: 480px; text-align: left">
                <template #header>
                  <div class="card-header">
                    <span>第1步 - 复制Json</span>
                    <el-button @click="copyText" type="primary" plain
                      >点击复制Json&nbsp;<el-icon><CopyDocument /></el-icon
                    ></el-button>
                  </div>
                </template>
                手动 复制&修改：
                <br />
                <el-input
                  v-model="generatedJson"
                  style="width: 100%"
                  :autosize="{ minRows: 2, maxRows: 20 }"
                  type="textarea"
                />
              </el-card>
              <br />
              <el-card style="max-width: 480px">
                <template #header>
                  <div class="card-header">
                    <span>第2步 - 下载构建器</span>
                    <el-button
                      tag="a"
                      rel="noopener noreferrer"
                      href="https://download.gusui.site/%E4%B8%8B%E8%BD%BD%E7%BA%BF%E8%B7%AF1%20[%E8%93%9D%E5%A5%8F%E4%BA%91%E5%88%86%E6%B5%81]/%E8%B0%B7%E7%A9%97%E7%A4%BE%E5%8C%BA%E4%BB%A3%E7%A0%81%E6%9E%84%E5%BB%BA%E5%99%A8"
                      target="_blank"
                      type="primary"
                      plain
                      >点击下载构建器&nbsp;<el-icon><Download /></el-icon
                    ></el-button>
                  </div>
                </template>
                如已下载查看下一个板块
              </el-card>
              <br />
              <el-card style="max-width: 480px; text-align: left">
                <template #header>
                  <div class="card-header">
                    <span>第3步 - 构建项目</span>
                    <!-- <el-button tag="a" rel="noopener noreferrer" href="https://download.gusui.site/%E4%B8%8B%E8%BD%BD%E7%BA%BF%E8%B7%AF1%20[%E8%93%9D%E5%A5%8F%E4%BA%91%E5%88%86%E6%B5%81]/%E8%B0%B7%E7%A9%97%E7%A4%BE%E5%8C%BA%E4%BB%A3%E7%A0%81%E6%9E%84%E5%BB%BA%E5%99%A8" target="_blank" type="primary" plain>点击下载构建器&nbsp;<el-icon><Download /></el-icon></el-button> -->
                  </div>
                </template>
                &emsp;&emsp;启动构建器，选择是否需要下载，如需下载请填写您获取到的模板文件的链接，并在下一步粘贴复制的Json，回车后根据软件提示即可开始构建项目。
              </el-card>
            </div>
            <div v-else>
              <el-card style="max-width: 480px; text-align: left">
                <template #header>
                  <div class="card-header">
                    <span>提交构建任务</span>
                    <el-button @click="uploadText" type="primary" plain
                      >点击提交任务&nbsp;<el-icon><Position /></el-icon
                    ></el-button>
                  </div>
                </template>
                输入项目资源包地址（/用户名/项目名）：
                <el-input v-model="g_from" />
                <br />
                <!-- 输入项目容器目标地址（项目名）：
                <el-input v-model="g_to" /> -->
                <br />
                手动 复制&修改 Json：
                <br />
                <el-input
                  v-model="generatedJson"
                  style="width: 100%"
                  :autosize="{ minRows: 2, maxRows: 20 }"
                  type="textarea"
                />
              </el-card>
              <!-- <br />
              <el-card >
                <template #header>
                  <div class="card-header">
                    <span>第2步 - 查看任务</span>
                    <el-button
                      tag="a"
                      rel="noopener noreferrer"
                      href="https://download.gusui.site/%E4%B8%8B%E8%BD%BD%E7%BA%BF%E8%B7%AF1%20[%E8%93%9D%E5%A5%8F%E4%BA%91%E5%88%86%E6%B5%81]/%E8%B0%B7%E7%A9%97%E7%A4%BE%E5%8C%BA%E4%BB%A3%E7%A0%81%E6%9E%84%E5%BB%BA%E5%99%A8"
                      target="_blank"
                      type="primary"
                      plain
                      >新页面查看&nbsp;<el-icon><TopRight /></el-icon>
                    </el-button>
                  </div>
                </template> -->
              <!-- <iframe id="myIframe" src="about:blank" style="width:90vw"></iframe> -->
              <!-- </el-card> -->
              <br />
            </div>
            <el-button style="margin-top: 12px" @click="pre">上一步</el-button>
            <el-button style="margin-top: 12px" @click="next">下一步</el-button>
          </el-card>

          <el-card style="max-width: 480px" v-if="active == 4">
            <template #header>
              <div class="card-header">
                <span>项目部署🔗</span>
                <el-button
                  tag="a"
                  rel="noopener noreferrer"
                  href="https://container.gusui.site"
                  target="_blank"
                  type="primary"
                  plain
                  >点击前往项目容器&nbsp;<el-icon><Link /></el-icon
                ></el-button>
              </div>
            </template>
            <div style="max-width: 480px; text-align: left">
              &emsp;&emsp;你可以通过<b>谷穗社区项目容器</b>部署你的静态项目。请注意！你仅可以部署静态项目（如HTML+CSS+JS），不可以部署PHP、Python等动态项目。
            </div>

            <el-button style="margin-top: 12px" @click="pre">上一步</el-button>
            <el-button style="margin-top: 12px" @click="next">下一步</el-button>
          </el-card>
          <el-card style="max-width: 480px" v-if="active == 5">
            <template #header>
              <div class="card-header">
                <span>部署完成🎉</span>
              </div>
            </template>
            <br />
            <h1>恭喜你！部署完成啦🎉</h1>
            <br />
            <el-button style="margin-top: 12px" @click="pre">上一步</el-button>
            <!-- <el-button style="margin-top: 12px" @click="next">下一步</el-button> -->
          </el-card>
          <!-- <input type="file" @change="onFileChange" /> -->
          <!-- <div>
           
            <table v-if="tableData.length">
              <thead>
                <tr>
                  <th>名称</th>
                  <th>描述</th>
                  <th>值</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in tableData" :key="index">
                  <td>{{ item.name }}</td>
                  <td>{{ item.describe }}</td>
                  <td><input type="text" v-model="item.value" /></td>
                </tr>
              </tbody>
            </table>
            <button @click="generateJson">提交</button>

            <p v-if="generatedJson" id="textToCopy">{{ generatedJson }}</p>
            
          </div> -->
        </center>
        <!-- <el-input v-model="jsonUrl" /> -->
        <!-- <button @click="loadData">提交json</button> -->
        <br /><br />
      </el-main>

      <!-- Footer -->
      <!-- 底部 -->
      <!-- <el-footer>{{ info.Message }}</el-footer> -->
      <el-footer class="pc">
        <center>
          Copyright © 2020-2024 <a href="http://www.gusui.site">谷穗社区工作室</a>
        </center>
      </el-footer>
      <el-footer class="m">
        <center>
          Copyright © 2020-2024 <a href="http://www.gusui.site">谷穗社区工作室</a>
        </center>
      </el-footer>
    </el-container>
  </div>

  <el-backtop :right="20" :bottom="20" />
</template>

<!-- <script src="https://cdn.staticfile.org/axios/0.18.0/axios.min.js"></script> -->
<!-- <script>
import { ElLoading } from 'element-plus'
const loadingInstance = ElLoading.service({ fullscreen: true })
document.onreadystatechange = function () {
  if (document.readyState == "complete") {
    loadingInstance.close();
    // loadingInstance.close();
    // loadingInstance.close();
    // loadingInstance.close();
    // loadingInstance.close();
  }
}
</script > -->
<script>
import { ref } from "vue";
// import { ref } from 'vue'
import axios from "axios";
import { ElNotification, ElMessage, ElMessageBox } from "element-plus";
import useClipboard from "vue-clipboard3";
import Cookies from "js-cookie";
// import 'github-markdown-css/github-markdown.css'
axios.defaults.withCredentials = false;
setTimeout(() => {
  const boxes = document.querySelectorAll(".box");
  console.log(boxes);
  window.addEventListener("scroll", () => {
    const tb = window.innerHeight;
    boxes.forEach((item) => {
      const boxTop = item.getBoundingClientRect().top;
      if (boxTop < (tb * 3) / 5) {
        item.classList.add("show");
      } else if (boxTop > tb) {
        item.classList.remove("show");
      }
    });
  });
}, 100);
export default {
  name: "App",
  data() {
    return {
      firstActiveName: "2",
      userinfo: {},
      form: {
        name: "",
        version: "",
        description: "",
      },
      options: [
        {
          value: 1,
          label: "云构建",
        },
        {
          value: 0,
          label: "本地构建",
        },
      ],
      value: 1,
      isLogin: 0,
      g_from: "",
      g_to: "",
      runid: "",
      j_url:"",
      f_url:""
    };
  },
  setup() {
    const tableData = ref([]);
    const generatedJson = ref("");
    const data = ref({});
    const jsonUrl = ref("");
    const form_name = ref("");
    const form_version = ref("");
    const form_description = ref("");
    const active = ref(0);
    const loadData = async () => {
      // 这里应该是一个真实的API请求或文件读取逻辑
      console.log(jsonUrl.value);
      const response = ref(null);
      try {
        if (jsonUrl.value === "") {
          ElNotification({
            title: "错误",
            dangerouslyUseHTMLString: true,
            message: "请输入内容！",
            type: "error",
          });
        } else {
          response.value = await axios.get(jsonUrl.value);
          try {
            if (response.value.headers["content-type"] === "application/json") {
              data.value = response.value.json();
            } else {
              console.error("Invalid JSON file");
              console.log(response.value.data);
              data.value = JSON.parse(JSON.stringify(response.value.data));
            }

            const fileData = data.value.data || []; // 确保data存在，否则使用空数组
            tableData.value = fileData.map((item) => ({ ...item, value: "" }));
            console.log("----------");
            console.log(tableData.value);
            form_name.value = data.value.name;
            form_version.value = data.value.version;
            form_description.value = data.value.description;
            active.value++;
            ElMessage({
              message: "资源解析成功",
              type: "success",
            });
          } catch (e) {
            ElNotification({
              title: "错误",
              dangerouslyUseHTMLString: true,
              message:
                '很抱歉，我们在解析文件时遇到了一个错误，请检查资源正确性！\n<p style="color:red;"><b>错误信息</b>：' +
                e +
                "</p>",
              type: "error",
            });
          }
        }
      } catch (e) {
        ElNotification({
          title: "错误",
          dangerouslyUseHTMLString: true,
          message:
            '很抱歉，我们在获取文件时遇到了一个错误，请检查资源路径！\n<p style="color:red;"><b>错误信息</b>：' +
            e +
            "</p>",
          type: "error",
        });
      }

      console.log("start");
    };

    const onFileChange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          data.value = JSON.parse(e.target.result);
          const fileData = data.value.data || []; // 确保data存在，否则使用空数组
          tableData.value = fileData.map((item) => ({ ...item, value: "" }));
          form_name.value = data.value.name;
          form_version.value = data.value.version;
          form_description.value = data.value.description;
          console.log(form_name.value);
          console.log(form_version.value);
          console.log(form_description.value);
          active.value++;
          ElMessage({
            message: "资源解析成功",
            type: "success",
          });
        } catch (error) {
          console.error("Invalid JSON file", error);
          ElNotification({
            title: "错误",
            dangerouslyUseHTMLString: true,
            message:
              '很抱歉，我们在解析文件时遇到了一个错误，请检查资源正确性！\n<p style="color:red;"><b>错误信息</b>：' +
              error +
              "</p>",
            type: "error",
          });
        }
      };
      reader.readAsText(file);
    };

    const generateJson = () => {
      try {
        const newData = {};
        tableData.value.forEach((item) => {
          newData[item.name] = item.value;
        });
        const newData2 = {
          name: form_name.value,
          version: form_version.value,
          description: form_description.value,
          data: newData,
        };
        generatedJson.value = JSON.stringify(newData2, null, 2);
        active.value++;
        ElMessage({
          message: "数据处理成功",
          type: "success",
        });
      } catch (error) {
        ElNotification({
          title: "错误",
          dangerouslyUseHTMLString: true,
          message:
            '很抱歉，我们在数据处理时遇到了一个错误，请检查资源正确性！\n<p style="color:red;"><b>错误信息</b>：' +
            error +
            "</p>",
          type: "error",
        });
      }
    };
    const { toClipboard } = useClipboard();

    // const text = ref('')

    const copyText = async () => {
      try {
        await toClipboard(generatedJson.value);
        console.log("复制成功");
        ElNotification({
          title: "复制成功",
          dangerouslyUseHTMLString: true,
          message: "Json复制成功！",
          type: "success",
        });
      } catch (e) {
        console.error(e);
        console.error("复制失败");
      }
    };
    return {
      tableData,
      onFileChange,
      generateJson,
      generatedJson,
      loadData,
      jsonUrl,
      form_version,
      form_name,
      form_description,
      active,
      copyText,
    };
  },
  methods: {
    // const active = ref(0)
    next() {
      if (this.active++ >= 5) this.active = 5;
    },
    pre() {
      if (this.active-- <= 0) this.active = 0;
    },
    login() {
      window.location.href = this.getSigninUrl();
    },
    account() {
      window.open("https://account.gusui.site/account");
    },
    logout() {
      Cookies.remove("gusui_login_token");
      location.reload();
    },
    trytologin() {  
      axios.defaults.withCredentials = false;
      let token = Cookies.get("gusui_login_token");
      axios
        .get("https://account.gusui.site/api/get-account?accessToken=" + token)
        .then((response) => {
          try {
            let data = response.data;
            if (data.status === "ok") {
              // Cookies.set('gusui_login_token', data.access_token,{expires: 30});
              console.log(data);
              this.isLogin = 1;
              this.userinfo = data;
            }
          } catch (error) {
            console.log(error);
            ElMessageBox.alert("解析用户信息失败" + error, {
              confirmButtonText: "好",
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    uploadText() {
      if (this.isLogin === 1) {
        if (this.g_from === "") {
          ElNotification({
            title: "错误",
            dangerouslyUseHTMLString: true,
            message: "请输入项目资源包地址！",
            type: "error",
          });
        }else{
        axios
          .get(
            "https://generate_api.gusui.site/cloud_generate/add_task?from=" +
              this.g_from +
              "&to=/" +
              this.userinfo.name +
              "/" +
              this.form_name +
              "&user=" +
              this.userinfo.name +
              "&json=" +
              this.generatedJson +
              "&name=" +
              this.from_name
            
          )
          // {
             //withCredentials: true,
            //}
          .then((response) => {
            try {
              let data = response.data;
              if (data.state === "ok") {
                // Cookies.set('gusui_login_token', data.access_token,{expires: 30});
                // console.log(data);
                // this.isLogin = 1;
                // this.userinfo=data;
                ElMessage({
                  message: "任务提交成功",
                  type: "success",
                });
                this.runid = data.id;
                window.location.href = "https://taskmgr.gusui.site/#/task/" + this.runid;
                // window.location.href='http://192.168.101.91:8080/#/task/'+this.runid;
                // document.getElementById('myIframe').src = 'http://192.168.101.91:8080/#/task/'+this.runid;
              }
            } catch (error) {
              console.log(error);
              ElMessageBox.alert("解析回调失败" + error, {
                confirmButtonText: "好",
                type: "error",
              });
            }
          })
          .catch((error) => {
            console.error(error);
            ElMessageBox.alert("请求失败" + error, {
              confirmButtonText: "好",
              type: "error",
            });
          });
        }
      } else {
        ElNotification({
          title: "错误",
          dangerouslyUseHTMLString: true,
          message:
            "你还没有登录！请复制Json并登录，待返回构建器一直点击下一步直到到达此步并粘贴Json，即可重新提交！",
          type: "error",
        });
      }
    },
    // copyText() {
    //   let text=document.getElementById("textToCopy").value;
    //   clipboard.writeText(text);
    // }
    // copyText() {
    //   var textToCopy = document.getElementById("textToCopy");
    //   textToCopy.select();
    //   textToCopy.setSelectionRange(0, 99999); // For mobile devices
    //   navigator.clipboard.writeText(textToCopy.value);
    //   // document.execCommand("copy");

    //   // Alert the copied text
    //   alert("已复制文本: " + textToCopy.value);
    // }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.code = urlParams.get("code");
    this.g_from = urlParams.get("furl");
    this.jsonUrl = urlParams.get("jurl");
    if(this.jsonUrl!=null) {
      this.loadData();
    }
    if (this.code != null) {
      axios
        .get("https://generate_api.gusui.site?code=" + this.code)
        .then((response) => {
          try {
            let data = response.data;
            console.log(data);
            if (data.access_token != undefined) {
              Cookies.set("gusui_login_token", data.access_token, { expires: 30 });
              this.trytologin();
            }
          } catch (error) {
            console.log(error);
            ElMessageBox.alert("解析信息失败", {
              confirmButtonText: "好",
              type: "error",
            });
          }
        })
        .catch((error) => {
          ElMessageBox.alert("获取信息失败" + error, {
            confirmButtonText: "好",
            type: "error",
          });
        });
    }
    this.trytologin();
  },
};
</script>

<!-- <script src="//cdn.jsdelivr.net/npm/@element-plus/icons-vue"></script> -->
<!-- <script setup>
import { ref } from 'vue';
import { Cloudy, Sunny } from '@element-plus/icons-vue';
const value1 = ref(true);

</script> -->
